var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("SLO LOGIN PAGE")])
}
var staticRenderFns = []

export { render, staticRenderFns }